import type { FC } from 'react';

interface ModerationMetricsProps {
  queueTotal: number;
  reportedCount: number;
  openReportsCount: number;
}

interface MetricCardProps {
  icon: string;
  label: string;
  value: number;
  change: string;
  accent: 'orange' | 'green';
}

/** Ported from the prototype's .metric-card (orange/green variants on the moderation page). */
const MetricCard: FC<MetricCardProps> = ({ icon, label, value, change, accent }) => (
  <div className="relative overflow-hidden rounded-2xl border border-[var(--color-divider)] bg-white p-5 px-[22px] shadow-[var(--shadow-card)] transition-all hover:-translate-y-0.5 hover:shadow-[var(--shadow-card-hover)]">
    <span
      className="pointer-events-none absolute right-0 top-0 h-20 w-20 translate-x-5 -translate-y-5 rounded-full opacity-[0.06]"
      style={{
        background: accent === 'orange' ? 'var(--color-brand-500)' : 'var(--color-success)',
      }}
    />
    <div className="mb-3 text-xl">{icon}</div>
    <div className="mb-1.5 text-[11.5px] font-semibold uppercase tracking-[0.5px] text-[var(--color-ink-muted)]">
      {label}
    </div>
    <div className="text-[26px] font-extrabold tracking-[-1px] text-[var(--color-ink)]">
      {value.toLocaleString()}
    </div>
    <div
      className={
        accent === 'orange'
          ? 'mt-1.5 text-[11.5px] font-semibold text-[var(--color-danger-ink)]'
          : 'mt-1.5 text-[11.5px] font-semibold text-[var(--color-success-ink)]'
      }
    >
      {change}
    </div>
  </div>
);

const ModerationMetrics: FC<ModerationMetricsProps> = ({
  queueTotal,
  reportedCount,
  openReportsCount,
}) => (
  <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
    <MetricCard
      icon="📥"
      label="In Queue"
      value={queueTotal}
      change={reportedCount > 0 ? `${reportedCount} reported` : 'Nothing flagged'}
      accent="orange"
    />
    <MetricCard
      icon="🚩"
      label="Open Reports"
      value={openReportsCount}
      change={openReportsCount > 0 ? 'Awaiting review' : 'All clear'}
      accent="green"
    />
  </div>
);

export default ModerationMetrics;
